import React from 'react'

const VersionHistory = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3606 16.0614C18.9077 20.3099 13.4751 21.7656 9.22655 19.3127C8.84392 19.0918 8.35464 19.2229 8.13373 19.6055C7.91282 19.9881 8.04392 20.4774 8.42655 20.6983C13.4404 23.5931 19.8515 21.8752 22.7463 16.8614C25.641 11.8475 23.9231 5.43638 18.9093 2.54165C13.9884 -0.299458 7.72139 1.30271 4.75407 6.10335L4.25364 4.52724C4.11994 4.10613 3.67017 3.87314 3.24906 4.00684C2.82795 4.14055 2.59496 4.59031 2.72866 5.01143L3.81391 8.42948C3.94761 8.85059 4.39738 9.08358 4.81849 8.94988L8.23655 7.86463C8.65766 7.73093 8.89065 7.28116 8.75695 6.86005C8.62324 6.43894 8.17348 6.20595 7.75236 6.33965L6.18182 6.83831C8.72265 2.85379 13.9763 1.54107 18.1093 3.92729C22.3579 6.38019 23.8135 11.8128 21.3606 16.0614Z"
      fill="#353F45"
    />
    <path
      d="M4.32039 17.9379L2.40039 22.7379L7.20039 21.7779L16.8004 12.1779V10.2579L14.4004 9.29785L4.32039 17.9379Z"
      fill="white"
      stroke="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.47395 24.5781C1.85123 24.9564 2.45841 24.774 2.45841 24.774L7.36924 23.1282C7.492 23.0862 7.60365 23.0179 7.6945 22.926L16.005 14.6011L16.006 14.6001L16.0074 14.599L16.857 13.7459C17.4954 13.1089 17.8598 12.381 17.9132 11.6437C17.9573 11.0497 17.8158 10.1487 16.8965 9.22942C15.9689 8.2983 15.0673 8.14398 14.4692 8.18352C13.723 8.22756 12.9916 8.58856 12.3532 9.22942H12.3508L3.18834 18.4109C3.09645 18.5028 3.02814 18.6151 2.98618 18.7369L1.29641 23.8235C1.29641 23.8235 1.20105 24.3041 1.47395 24.5781ZM13.5281 10.4106L13.5281 10.4098C13.5283 10.4094 13.5288 10.4091 13.5305 10.4081C13.7694 10.1668 14.1477 9.87201 14.5704 9.84635C14.9415 9.82519 15.326 10.0135 15.7193 10.4081C16.0976 10.7889 16.2786 11.1627 16.2533 11.5213C16.2231 11.9427 15.9245 12.321 15.6797 12.5648V12.5669L15.4176 12.8304L13.2656 10.6738L13.5281 10.4106ZM12.0883 11.8535L4.50465 19.4519L3.42726 22.6857L6.6563 21.6086L14.2403 14.0102L12.0883 11.8535Z"
      fill="#353F45"
    />
  </svg>
)

export default VersionHistory
